import * as api from '../api';

export function sendTchapMessage(event, texte, texteHtml) {
    let data;
    data = {
            	"event": event,
            	"message": texte,
            	"textehtml": texteHtml,
            };
    return api.sendTchapMessage(data)
        .then((result) => {
            console.log(result);
        })
        .catch((error) => {
            console.error("Erreur sendTchapMessage:", error);
            throw error;
        });
}
